import React from 'react'
import PropTypes from 'prop-types'

import { Button, Dropdown, Popup } from 'semantic-ui-react'

import PopupButton from 'Components/PopupButton'
import SortingDropdownItem from 'Components/SortingDropdownItem'

import * as styles from './styles'
import { getSortByIcon } from 'Global/Helpers/iconHelpers'

const MySearchesLayoutButtonGroup = props => {
  const { handleSort, layout, limit, sortBy, sortOrder, toggleLayout, toggleLimit } = props

  return (
    <div style={styles.buttonGroup}>
      <Button.Group icon floated="right">
        {layout === 'gridLayout' && (
          <Popup
            content="Sorting"
            size="mini"
            trigger={
              <Dropdown icon={getSortByIcon(sortBy)} button floating>
                <Dropdown.Menu>
                  <SortingDropdownItem
                    active={sortBy === 'name'}
                    icon="tag"
                    handleSort={handleSort}
                    name="name"
                    sortOrder={sortOrder}
                    text="Name"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'rugs'}
                    icon="search"
                    handleSort={handleSort}
                    name="rugs"
                    sortOrder={sortOrder}
                    text="Results"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'dateCreated'}
                    icon="calendar"
                    handleSort={handleSort}
                    name="dateCreated"
                    sortOrder={sortOrder}
                    text="Saved Date"
                  />
                </Dropdown.Menu>
              </Dropdown>
            }
          />
        )}

        <PopupButton onClick={toggleLimit} popupContent="Results per Page" text={limit.toString()} />

        <PopupButton onClick={toggleLayout} popupContent="Layout" icon={layout === 'gridLayout' ? 'table' : 'grid layout'} />
      </Button.Group>
    </div>
  )
}

MySearchesLayoutButtonGroup.propTypes = {
  exportToExcel: PropTypes.func,
  handleSort: PropTypes.func.isRequired,
  layout: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  toggleLayout: PropTypes.func,
  toggleLimit: PropTypes.func.isRequired,
}

export default MySearchesLayoutButtonGroup
